module.exports = __webpack_public_path__ + "static/5i-47bfcca6b69d6a9acca7a8bff17193e2.woff2";